/**
 * File icons: a codicon by file name, so a C file reads as one at a glance.
 * All icons are one neutral color (workbench.css); the glyph tells the types
 * apart.
 */
const BY_NAME: Record<string, string> = {
    "CMakeLists.txt": "tools",
    Kconfig: "settings-gear",
    "Kconfig.projbuild": "settings-gear",
    "idf_component.yml": "package",
    "dependencies.lock": "lock",
    "partitions.csv": "table",
    ".gitignore": "git-commit",
};

const BY_EXTENSION: Record<string, string> = {
    c: "file-code",
    cpp: "file-code",
    cc: "file-code",
    h: "file-code",
    hpp: "file-code",
    s: "file-binary",
    cmake: "tools",
    md: "markdown",
    json: "json",
    py: "file-code",
    yml: "file",
    yaml: "file",
    csv: "table",
    ld: "file-code",
    elf: "file-binary",
    bin: "file-binary",
    map: "file",
    txt: "file",
    png: "file-media",
    jpg: "file-media",
    svg: "file-media",
};

export function fileIcon(path: string): HTMLElement {
    const name = path.slice(path.lastIndexOf("/") + 1);
    const ext = name.includes(".") ? name.slice(name.lastIndexOf(".") + 1).toLowerCase() : "";
    const glyph =
        BY_NAME[name] ?? (name.startsWith("sdkconfig") ? "settings-gear" : undefined) ?? BY_EXTENSION[ext] ?? "file";
    const element = document.createElement("span");
    element.className = `codicon codicon-${glyph} wb-file-icon`;
    return element;
}
